import { useQuery } from "@tanstack/react-query";
import { getEmployeeUnderManager } from "../../../services/manager/apiEmloyeeUnderManager";

export const EmployeeUnderManagerQuery = (status = "Active") => {
  const { data, isLoading } = useQuery({
    queryKey: ["employeeUnderManager", status],
    queryFn: () => getEmployeeUnderManager(status),
  });

  const employeeList = data?.data;

  return { employeeList, isLoading };
};
